import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Select from "react-select";
import Card from "components/Card/Card.jsx";
import Datetime from "react-datetime";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  addNewNotification,
  searchMedicationForSubProduct,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class AddNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      errormessages: [],
      title: "",
      titleError: null,
      content: "",
      contentError: null,
      link: "",
      linkError: null,
      itemCode: "",
      itemCodeError: null,
      discount: "",
      discountError: null,
      medication: "",
      external_url: "",
      external_error: "",
      isSubimitted: false,
      medicationError: null,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Notification Template</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });

    setTimeout(() => {
      this.props.history.push("/admin/notifications");
    }, 3000);
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    if (this.state.isSubimitted) {
      this.validate(value, name);
    }

    this.setState({
      [name]: value,
    });
  };

  validate = (value, name) => {
    if (name == "external_url") {
      var url_re =
        /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
      if (this.state.link == null || this.state.link == "") {
        if (value == "" || value == null) {
          this.setState({
            external_error: (
              <small className="text-danger">Please enter external link</small>
            ),
          });
        } else if (url_re.test(value) == false) {
          this.setState({
            external_error: (
              <small className="text-danger">
                Please add valid external link
              </small>
            ),
          });
        } else {
          this.setState({
            external_error: null,
          });
        }
      } else {
        this.setState({
          external_error: null,
        });
      }
    }

    if (name == "link") {
      if (value != "") {
        this.setState({
          external_error: null,
        });
      }
    }
  };

  inputOnChange = (event, i) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      name: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParent(self.state.name.trim());
      }, 500),
    });
  };

  sendToParent = async (name) => {
    //this.props.searching(this.state.name);c

    if (this.state.name.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));

      const obj = token.token;

      await searchMedicationForSubProduct(this.state.name, obj).then((res) => {
        var mdata = res.data.data;

        var medicationItems = [];

        // var medicationItems = this.state.itemCode;
        //alert("in else")
        this.setState({ medication_detail: [] });

        res.data.data.map((x, i) => {
          medicationItems.push({
            value: x.item_code,
            label: x.title + " (" + x.item_code + ")",
          });
        });

        this.setState({
          medicationItems: medicationItems,
        });
      });
    } else {
      this.setState({ medication_detail: [], medicationItems: [] });
    }
  };

  handleSelectChange = (value) => {
    this.setState({
      medication: value.value,
    });
    // this.getMedicinDetailById(value.value)
  };

  onSubmit = () => {
    this.setState({ errormessages: [], isSubimitted: true });
    let error = false;
    if (this.state.title.length == 0) {
      error = true;
      this.setState({
        titleError: <small className="text-danger">Title is required.</small>,
      });
    } else {
      this.setState({ titleError: null });
    }

    // if (this.state.link === "Raya Screen") {
    //   if (this.state.itemCode.length == 0) {
    //     error = true;
    //     this.setState({
    //       itemCodeError: (
    //         <small className="text-danger">Item Code is required.</small>
    //       ),
    //     });
    //   } else {
    //     this.setState({ itemCodeError: null });
    //   }

    //   if (this.state.discount.length == 0) {
    //     error = true;
    //     this.setState({
    //       discountError: (
    //         <small className="text-danger">Discount is required.</small>
    //       ),
    //     });
    //   } else {
    //     this.setState({ discountError: null });
    //   }
    // }

    var url_re =
      /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    if (this.state.link == null || this.state.link == "") {
      if (this.state.external_url == "" || this.state.external_url == null) {
        error = true;
        this.setState({
          external_error: (
            <small className="text-danger">Please enter external link</small>
          ),
        });
      } else if (url_re.test(this.state.external_url) == false) {
        error = true;
        this.setState({
          external_error: (
            <small className="text-danger">
              Please add valid external link
            </small>
          ),
        });
      } else {
        this.setState({
          external_error: null,
        });
      }
    } else {
      this.setState({
        external_error: null,
      });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      addNewNotification(
        this.state.title,
        this.state.content,
        this.state.link,
        this.state.medication,
        this.state.discount,
        this.state.external_url,
        obj
      )
        .then((res) => {
          if (res.data.success === false) {
            let message = res.data.data;
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl", error);
          console.log(error, "== error");
        });
    }
  };
  render() {
    const errormessages = this.state.errormessages;

    console.log("{this.state.medication", this.state.medication);
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.coupon_code_error}
        />
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}

                    <FormGroup>
                      <ControlLabel> Title</ControlLabel>
                      <FormControl
                        name="title"
                        value={this.state.title}
                        onChange={(event) => {
                          this.setState({ title: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                titleError: (
                                  <small className="text-danger">
                                    Coupon Title is required.
                                  </small>
                                ),
                              })
                            : this.setState({ titleError: null });
                        }}
                        placeholder="Enter Title"
                        type="text"
                      />
                      {this.state.titleError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel> content</ControlLabel>
                      <FormControl
                        name="content"
                        value={this.state.content}
                        onChange={(event) => {
                          this.setState({ content: event.target.value });
                        }}
                        placeholder="Enter Content"
                        type="textarea"
                      />
                      {this.state.contentError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Screen Link</ControlLabel>
                      <select
                        class="mdb-select md-form"
                        searchable="Search here.."
                        name="link"
                        value={this.state.link}
                        onChange={this.onChange}
                        className="form-control"
                      >
                        <option value="">Choose Screen Link</option>
                        <option value="Medicine Order Screen">
                          Medicine Order Screen
                        </option>
                        <option value="Lab order Screen">
                          Lab order Screen
                        </option>
                        <option value="Raya Screen">Raya Screen</option>
                        <option value="Wallet Screen">Wallet Screen</option>
                        <option value="Refer & Earn">Refer & Earn</option>
                        <option value="My Order - Raya">My Order - Raya</option>
                        <option value="Leaderboard">Leaderboard</option>
                        <option value="Move & Earn - Homepage">
                          Move & Earn - Homepage
                        </option>
                        <option value="Steps Screen">Steps Screen</option>
                        <option value="Calories Screen">Calories Screen</option>
                        <option value="Points Screen">Points Screen</option>
                        <option value="Leaderboard Permission Screen">
                          Leaderboard Permission Screen
                        </option>
                        <option value="First Advice Screen">
                          First Advice Screen
                        </option>
                        <option value="Test 1">Test 1</option>
                        <option value="Medi Products">Medi Products</option>
                        <option value="Consultation Detail Screen">
                          Consultation Detail Screen
                        </option>
                      </select>

                      {this.state.linkError}
                    </FormGroup>
                    {this.state.link === "Raya Screen" && (
                      <>
                        <FormGroup>
                          <ControlLabel>Item Code</ControlLabel>
                          <div
                            onKeyUp={(e) => this.inputOnChange(e)}
                            className="Appy"
                          >
                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              name="description"
                              //value={this.state.medicationItems}
                              onChange={(value) =>
                                this.handleSelectChange(value)
                              }
                              options={this.state.medicationItems}
                              placeholder="Enter Item Name or Code"
                              noOptionsMessage={() => "Type Item Name or Code"}
                            />
                          </div>
                          {this.state.itemCodeError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Discount</ControlLabel>
                          <FormControl
                            name="discount"
                            value={this.state.discount}
                            onChange={(event) => {
                              this.setState({ discount: event.target.value });
                            }}
                            placeholder="Enter Discount"
                            type="text"
                          />
                          {this.state.discountError}
                        </FormGroup>
                      </>
                    )}
                    <FormGroup>
                      <ControlLabel>External Link</ControlLabel>
                      <FormControl
                        name="external_url"
                        value={this.state.external_url}
                        onChange={this.onChange}
                        placeholder="Enter External Link"
                        type="text"
                      />
                      {this.state.external_error}
                    </FormGroup>
                    <Button
                      onClick={this.onSubmit.bind(this)}
                      class="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default AddNotification;
